import React, { useMemo } from 'react'
import ReactApexChart from 'react-apexcharts'
import ReportSummaryCard from './ReportSummaryCard'
import { useWorkforce } from '../../../../../../Context'
import { formatMonthLabel, parseMonthKey } from '../../../../adapters/workforceDetailAdapter'

const AXIS_LABEL_STYLE = {
  colors: '#535862',
  fontSize: '12px',
  fontFamily: 'Inter, sans-serif',
  fontWeight: 400,
}

export default function NewCreditFacilitiesCard() {
  const { workforceDetailReport } = useWorkforce()
  const series = workforceDetailReport?.credit_overview?.new_credit_facilities ?? []

  const { categories, data } = useMemo(() => {
    const sorted = [...series].sort((a, b) => parseMonthKey(a.date) - parseMonthKey(b.date))
    return {
      categories: sorted.map((d) => formatMonthLabel(d.date)),
      data: sorted.map((d) => Number(d.count) || 0),
    }
  }, [series])

  const options = {
    chart: {
      type: 'bar',
      toolbar: { show: false },
      zoom: { enabled: false },
    },
    plotOptions: {
      bar: {
        borderRadius: 4,
        columnWidth: '55%',
      },
    },
    colors: ['#14378E'],
    dataLabels: { enabled: false },
    legend: { show: false },
    grid: {
      borderColor: '#e9eaeb',
      strokeDashArray: 0,
      xaxis: { lines: { show: false } },
      yaxis: { lines: { show: true } },
      padding: { left: 0, right: 8 },
    },
    xaxis: {
      categories,
      labels: { style: AXIS_LABEL_STYLE },
      axisBorder: { show: false },
      axisTicks: { show: false },
      title: {
        text: 'Month',
        style: {
          color: '#535862',
          fontSize: '12px',
          fontFamily: 'Inter, sans-serif',
          fontWeight: 500,
        },
        offsetY: 4,
      },
    },
    yaxis: {
      min: 0,
      tickAmount: 5,
      labels: {
        style: AXIS_LABEL_STYLE,
        formatter: (val) => Math.round(val).toLocaleString(),
      },
      title: {
        text: '# of new facilities',
        style: {
          color: '#535862',
          fontSize: '12px',
          fontFamily: 'Inter, sans-serif',
          fontWeight: 500,
        },
      },
    },
    tooltip: {
      y: { formatter: (val) => `${val} facility/ies` },
    },
  }

  const seriesOpt = [{ name: 'New facilities', data }]
  const isEmpty = data.length === 0 || data.every((v) => v === 0)

  return (
    <ReportSummaryCard
      title="New Credit Facilities"
      description="Newly issued credit facilities over time, indicating borrowing activity and credit demand behavior."
      onViewReport={false}
    >
      <div className="w-full pt-2 pb-2">
        {isEmpty ? (
          <div className="flex items-center justify-center h-[251px] text-sm text-gray-500">
            No new credit facilities recorded.
          </div>
        ) : (
          <ReactApexChart options={options} series={seriesOpt} type="bar" height={251} />
        )}
      </div>
    </ReportSummaryCard>
  )
}
